if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        
      }

      get selectedOptionValues() {
        return Array.from(
          this.querySelectorAll('select option[selected], fieldset input:checked')
        ).map(({ dataset }) => dataset.optionValueId);
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {


        // When any 'change' event occurs inside variant-selects, call our methods
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);

          this.updateSelectedSwatchValue(event);

          // Original publishing logic (likely needed by your theme):
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });

          // 3. On every change, update the label backgrounds
          this.applyBackgroundImages();
        });

        // 4. Call the background assignment method once when the component loads
        this.applyBackgroundImages();
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            ?.removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            ?.querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;

          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target
            .closest(`.product-form__input`)
            ?.querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }

      // 5. This method assigns background images to labels depending on the text
      applyBackgroundImages() {

      // 1. Get the <product-info> element (by ID or any other selector)
      const productInfoEl = document.querySelector('product-info');

      let leinwandurl = '',
              aluminiumurl = '',
              acrylurl = '';
        // 2. Read the links from the data attributes
        if (productInfoEl) {
          leinwandurl = productInfoEl.dataset.leinwand || '';
          aluminiumurl = productInfoEl.dataset.aluminium || '';
          acrylurl = productInfoEl.dataset.acryl || '';
        }

        
        // Find all <label> elements inside this custom element
        const labels = this.querySelectorAll('label');

        labels.forEach((label) => {
          const text = label.textContent.trim();

          // Reset any old styles or classes
          label.classList.remove('label-material');
          label.style.background = '';

          
          if (text.includes('Leinwand') || text.includes('Canvas') || text.includes('Tela') || text.includes('Lienzo')) {
            label.style.background = 'url(' + leinwandurl + ')';
            label.style.backgroundPosition = 'center';
            label.style.backgroundRepeat = 'no-repeat';
            label.style.backgroundSize = 'cover';
            label.classList.add('label-material');
          } else if (text.includes('Aluminium') || text.includes('Aluminum') || text.includes('Alluminio') || text.includes('Aluminio')) {
            label.style.background = 'url(' + aluminiumurl + ')';
            label.style.backgroundPosition = 'center';
            label.style.backgroundRepeat = 'no-repeat';
            label.style.backgroundSize = 'cover';
            label.classList.add('label-material');
          } else if (text.includes('Acrylglas') || text.includes('Acrylic Glass') || text.includes('Vetro acrilico') || text.includes('Vidrio acrílico')) {
            label.style.background = 'url(' + acrylurl + ')';
            label.style.backgroundPosition = 'center';
            label.style.backgroundRepeat = 'no-repeat';
            label.style.backgroundSize = 'cover';
            label.classList.add('label-material');
          }
        });
      }
    }
  );
}
